//
// AbstractOperation.js
// transport
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../../lib";

var AbstractOperation = createModule("transport::AbstractOperation", [], EventDispatcher, [
    {
        DOWNLOAD_CANCELLED: 60020,
        DOWNLOAD_INSIGHT_REPORT_PACKAGE_COMPLETED: 60033,
        DOWNLOADING_ASSETS_COMPLETED: 60013,
        CREATE_AND_SAVE_INSIGHT_COMPLETED: 60035,
        PREVIEW_GENERATED: 60016,
        DOWNLOAD_COMPLETED: 60018,
        DOWNLOADING_IMAGES: 60014,
        PREVIEW_GENERATION_COMPLETED: 60017,
        DOWNLOAD_SASDRIVE_FILE_FAILED: 60044,
        SYNC_SASDRIVE_FILES_COMPLETED: 60045,
        REPORT_INITIALIZED: 60004,
        SUBSCRIPTION_CANCELLED: 60007,
        NOTHING_TO_DOWNLOAD: 60010,
        DOWNLOADING_ASSETS_STARTED: 60011,
        DOWNLOAD_INSIGHT_REPORT_PACKAGE_FAILED: 60034,
        SEARCH_FINISHED: 60028,
        REPORT_META_UPDATED: 60005,
        REMOVE_FROM_FAVORITES_COMPLETED: 60031,
        GET_INSIGHT_FAILED: 60038,
        CREATE_AND_SAVE_INSIGHT_FAILED: 60036,
        SYNC_INSIGHTS_FAILED: 60040,
        SEARCH_STARTED: 60022,
        SUB_SEARCH_NOT_SUPPORTED: 60025,
        ADD_TO_FAVORITES_FAILED: 60030,
        INITIALIZING_REPORT: 60003,
        SUB_SEARCH_FINISHED: 60024,
        APPLIED: 60000,
        DOWNLOAD_SASDRIVE_FILE_COMPLETED: 60043,
        DOWNLOADING_ASSETS: 60012,
        SUB_SEARCH_FINISHED_NO_RESULTS: 60026,
        SYNC_INSIGHTS_COMPLETED: 60039,
        COMMITTED: 60001,
        ROLLED_BACK: 60002,
        UPDATE_INSIGHT_FAILED: 60042,
        DOWNLOAD_FAILED: 60021,
        ADD_TO_FAVORITES_COMPLETED: 60029,
        SUB_SEARCH_FINISHED_ERROR: 60027,
        GET_INSIGHT_COMPLETED: 60037,
        UPDATE_INSIGHT_COMPLETED: 60041,
        REMOVE_FROM_FAVORITES_FAILED: 60032,
        SUBSCRIPTION_COMPLETED: 60006,
        START_GENERATING_PREVIEWS: 60015,
        SUBSCRIPTION_FAILED: 60008,
        DOWNLOAD_WILL_RETRY: 60019,
        SUB_SEARCH_WILL_FINISH: 60023,
        WAITING_TO_DOWNLOAD: 60009,
        SYNC_SASDRIVE_FILES_FAILED: 60046,
    },
    ,
    ,
    ,
    {
        cancel: [0],
        apply: [0],
        isEqual: [2,1],
        isPending: [2],
    },
    {
        _createSearchOperation_osno: [1,1,7,4,1],
        createRemoveFromFavoritesOperation: [1,1,1],
        _createSubscribeOperation_ooso: [1,1,1,7,1],
        createUnsubscribeOperation: [1,1,1],
        _createSearchOperation_oso: [1,1,7,1],
        _createSubscribeOperations_oob: [[1],1,[1],2],
        createRemoveFromFavoritesOperations: [[1],1,[1]],
        _createSubscribeOperation_oo: [1,1,1],
        _createSubscribeOperation_oob: [1,1,1,2],
        createUnsubscribeManyOperation: [1,1,[1]],
        createUnsubscribeAllOperation: [1,1],
        createAddToFavoritesOperation: [1,1,1],
        _createSubscribeOperations_oo: [[1],1,[1]],
        _createSearchOperation_ooso: [1,1,1,7,1],
        createClearHistoryOperation: [1,1,1],
        _createDownloadOperation_oo: [1,1,1],
        _createSubscribeOperation_ooo: [1,1,1,1],
        _createSubscribeOperation_oos: [1,1,1,7],
        _createDownloadOperation_ooo: [1,1,1,1],
        createAddToFavoritesOperations: [[1],1,[1]],
        _createSubscribeOperationForLink_ooo: [1,1,1,1],
        _createSubscribeOperationForLink_ooso: [1,1,1,7,1],
        _createDownloadOperation_oob: [1,1,1,2],
        _createSubscribeOperation_oosb: [1,1,1,7,2],
        createAddToHistoryOperation: [1,1,1],
        _createSubscribeOperations_ooo: [[1],1,[1],1],
    },
    ,
    ["createSubscribeOperationForLink","createSubscribeOperation","createDownloadOperation","createSubscribeOperations","createSearchOperation"]
]);
export default AbstractOperation;
